import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Grid, Typography } from '@material-ui/core/'
import moment from 'moment'
import apiChat from '../../../../../../api/chat'
import { setChatCategoryOpen, setMeeting, setGetChats } from '../../../../../../modules/chatCategory/actions'
import { DateInput, TimeInput, Button } from 'components/UI/'
import c from 'classnames'
import './index.scss'

const DateAvtor = ({ name, setOpen, onEddit, getMeeting, newTitle, newDate }) => {
  const [date, setDate] = useState(new Date())
  const [time, setTime] = useState(new Date())
  const [disableBtn, setDisableBtn] = useState(true)
  const { user } = useSelector(({ session }) => session)
  const { chatUser } = useSelector(({ chat }) => chat)
  const history = useHistory()
  const dispath = useDispatch()
  const dateHandler = () => {
    if (time) {
      if (date) {
        return moment(new Date(date?.getFullYear(), date?.getMonth(), date?.getDate(), time?.getHours(), time?.getMinutes(), time?.getSeconds(), time?.getMilliseconds()))?.valueOf()
      }
    }
  }
  const createMeetDate = () => {
    if (dateHandler()) {
      apiChat.createMeeting(user?.accessKey, chatUser?.uuid, dateHandler())
        .then(() => {
          dispath(setGetChats(true))
        })
    }
  }

  const edditMeetingDate = () => {
    apiChat.edditMeetingTime(user?.accessKey, chatUser?.meeting?.uuid, dateHandler())
      .then(data => {
        dispath(setMeeting(data?.data?.meeting))
        setOpen(false)
        history.push('/chat/meeting-chat')
        dispath(setChatCategoryOpen('panel3'))
        dispath(setGetChats(true))
      })
  }

  useEffect(() => {
    if (newDate) {
      setDate(new Date(newDate))
      setTime(new Date(newDate))
    }
  }, [newDate])

  return (
    <Grid className='avtorDateContainer'>
      <Typography className='userNameMeet'>
        {newTitle ? `Meeting with ${name}` : 'Suggested meeting time:'}
      </Typography>
      <Typography className='dateTitleInput'>
        Date
      </Typography>
      <DateInput date={date} setDate={setDate} />
      <Typography className='timeTitleInput'>
        Time
      </Typography>
      <TimeInput setDisableBtn={setDisableBtn} time={time} setTime={setTime} />
      <Grid className='wrapperBtnMeet'>
        {onEddit ? (
          <Button disable={disableBtn} className={c('btnDateSchedule', disableBtn && 'btnDateScheduleDisable')} onClick={edditMeetingDate}>
            Schedule
          </Button>
        ) : (
          <Button disable={disableBtn} className={c('btnDateSchedule', disableBtn && 'btnDateScheduleDisable')} onClick={createMeetDate}>
            Schedule
          </Button>
        )}
      </Grid>
    </Grid>
  )
}

export default DateAvtor
